export default "__VITE_ASSET__BPXbax7j__"